import { Wrench } from "lucide-react";

import { type PunchupDashboardSidebarItem } from "@punchup/ui-common/punchup/composites/navigation/dashboard-sidebar/PunchupDashboardSidebar";

// `active` is always false: the Internal row leaves this surface, so it is never
// the current page.

// Only staff see the internal tools, which is what the "Staff" badge reports.
// `label` is the Mixpanel key, so it stays "Internal".
const INTERNAL: PunchupDashboardSidebarItem = {
  label: "Internal",
  title: "Internal portal",
  url: "/internal",
  Icon: Wrench,
  badgeLabel: "Staff",
  active: false,
};

interface DashboardFooterItemsOptions {
  /**
   * `undefined` while the lookup is in flight, so the Internal row stays hidden
   * rather than flashing for a non-admin.
   */
  isSuperAdmin?: boolean;
  /** The surface's "Settings" row, when the user has one. */
  settingsEntry?: PunchupDashboardSidebarItem;
}

/**
 * The rows pinned below the destinations of the dashboard nav, as against
 * `useDashboardMenuItems()`, which lists the destinations.
 *
 * A plain function rather than a hook, and here rather than in the app, because
 * BOTH navs need it: the desktop rail and the mobile drawer. The drawer lives in
 * this package and can hold no app hook, so the caller reads `isSuperAdmin` and
 * the settings gate, and this derives the list.
 *
 * Internal comes first, for super admins on either dashboard. The Settings row
 * comes under it.
 */
export function dashboardFooterItems({
  isSuperAdmin,
  settingsEntry,
}: DashboardFooterItemsOptions): PunchupDashboardSidebarItem[] {
  return [
    ...(isSuperAdmin ? [INTERNAL] : []),
    ...(settingsEntry ? [settingsEntry] : []),
  ];
}
